import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=19116b6b&"
import script from "./PageTitleBar.vue?vue&type=script&lang=js&"
export * from "./PageTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageTitleBar.vue"
export default component.exports